import React, { useEffect, useState } from 'react';
import Card from '../components/CardKana';
import data from './../data/hiragana.json';
import BackToTopButton from '../components/BackToTopButton';

const Hiragana = () => {

    const [showAll, setShowAll] = useState(undefined); // undefined = normal card behavior
    const [resetSignal, setResetSignal] = useState(0);
    const [pendingMap, setPendingMap] = useState({});

    const handleShowAll = () => {
        setShowAll(true);
    };

    const handleHideAll = () => {
        setShowAll(false);
    };

    const handleReset = () => {
        // 1. Clear override
        setShowAll(undefined);

        // 2. Remove all saved localStorage
        data.forEach(k => {
            localStorage.removeItem(`hiragana-${k.symbol}`);
        });

        for (let key in localStorage) {
            if (key.startsWith("hiraganaPending")) {
                localStorage.removeItem(key);
            }
        }

        // 3. Wait a tick to ensure showAll is undefined before resetting
        setTimeout(() => {
            setResetSignal(prev => prev + 1);
            setPendingMap({});
        }, 50);
    };

    useEffect(() => {
        const pending = JSON.parse(localStorage.getItem('hiraganaPending') || '{}');
        setPendingMap(pending);
    }, []);

    const handleTogglePending = (symbol) => {
        setPendingMap((prev) => {
            const updated = { ...prev, [symbol]: !prev[symbol] };
            localStorage.setItem('hiraganaPending', JSON.stringify(updated));
            return updated;
        });
    };

    return (
        <div className="px-6 pb-6 pt-6">
            <h1 className="text-4xl font-extrabold text-gray-800 mb-8 text-center">
                HIRAGANA
            </h1>
            <div className="flex justify-center space-x-4 mb-4">
                <button
                    onClick={handleShowAll}
                    className="px-4 py-2 bg-green-400 text-white rounded hover:bg-green-500 active:scale-95 transition-transform"
                >
                    Show All Details
                </button>
                <button
                    onClick={handleHideAll}
                    className="px-4 py-2 bg-red-400 text-white rounded hover:bg-red-500 active:scale-95 transition-transform"
                >
                    Hide All Details
                </button>
                <button
                    onClick={handleReset}
                    className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500 active:scale-95 transition-transform"
                >
                    Reset All
                </button>
            </div>
            <h3 className="text-gray-600 mb-8 text-center">
                Single tap - Play pronunciation<br />
                Double tap - Show / hide details<br />
                Long press - Mark / unmark for review
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 ">
                {data.map(data => (
                    <Card key={data.symbol}
                        symbol={data.symbol}
                        reading={data.pronounciation}
                        showOverride={showAll}
                        resetSignal={resetSignal}
                        page='hiragana'
                        isPending={pendingMap[data.symbol]}
                        onTogglePending={handleTogglePending}
                    />
                ))}
            </div>
            <BackToTopButton />
        </div>
    );
};

export default Hiragana;